
// import { testWelcomeEmail } from "~/functions/users/invites/test";
// import { useAuthContext } from "~/contexts/auth-context";
// import { Prompt } from "@logto/browser";

import { createFileRoute } from "@tanstack/react-router";
import { AdminOrgListPage } from "~/pages/admin/admin-org-list-page";

export const Route = createFileRoute("/admin/orgs/")({
  component: AdminOrgListPage,
});

